// extracted by mini-css-extract-plugin
module.exports = {"navBack":"NavBack_navBack__1m3yb","customLink":"NavBack_customLink__ctTgw","arrow":"NavBack_arrow__1IBZ1","left":"NavBack_left__2jPBX","customMargin":"NavBack_customMargin__1UE_w"};